"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.multipleSubmitted = void 0;
exports.multipleSubmitted = [
    {
        type: "CLINICAL",
        guid: "2de89d07-aa78-464d-bf0c-91ed251b30eb",
        billing_type: "BWF PATHOLOGY LAB",
        charge_code_type: "Split",
        patient_type: "",
        filler_number: {
            number: "FCP-22-N00335",
            issuer: "EPIC",
            type: "SPECIMEN_NUMBER"
        },
        billing_provider_number: {
            number: "1004910",
            issuer: "EPIC",
            type: "IDNO"
        },
        ordering_provider_number: {
            number: "1004910",
            issuer: "EPIC",
            type: "IDNO"
        },
        performing_provider_number: {
            number: "1004910",
            issuer: "EPIC",
            type: "IDNO"
        },
        transactions: [
            {
                guid: "b537d729-ddb7-4ced-a92d-08fa6a9a9efa",
                sequence_number: 1000,
                date_of_service: "2022-07-09",
                datetime_of_service: "2022-07-09 00:00:00 EDT",
                transaction_type: "CG",
                transaction_id: 921309,
                source_transaction_id: "L33690764",
                transaction_posting_date: "2022-07-10",
                transaction_description: "A",
                alt_transaction_description: "Polarization microscopy for crystals-FH",
                department_code: "10040010018",
                fee_schedule: "5000897",
                place_of_service: "FH_BWFNUR6N",
                custom_values: {
                    specimen_part: "A"
                },
                procedure: {
                    procedure_id: null,
                    procedure_uid: null,
                    evidence_source_uid: null,
                    procedure_name: null,
                    procedure_code: "89060",
                    type: null,
                    units: 1,
                    sequence_number: 1,
                    transaction_id: null,
                    automate: false,
                    confidence: 0,
                    evidence: [],
                    used: true
                },
                modifiers: [],
                diagnoses: [
                    {
                        diagnosis_uid: null,
                        diagnosis_code: "M25.432",
                        evidence_source_uid: null,
                        automate: false,
                        confidence: 0,
                        sequence_number: 1,
                        type: "ICD10",
                        evidence: [],
                        used: true
                    }
                ]
            }
        ]
    },
    {
        type: "ASSEMBLED",
        guid: "8ccc5e4f-9781-4adf-a0a2-8e2431362ee8",
        billing_type: "BWF PATHOLOGY LAB",
        charge_code_type: "Split",
        patient_type: "",
        filler_number: {
            number: "FCP-22-N00335",
            issuer: "EPIC",
            type: "SPECIMEN_NUMBER"
        },
        billing_provider_number: {
            number: "1004910",
            issuer: "EPIC",
            type: "IDNO"
        },
        ordering_provider_number: {
            number: "1004910",
            issuer: "EPIC",
            type: "IDNO"
        },
        performing_provider_number: {
            number: "1004910",
            issuer: "EPIC",
            type: "IDNO"
        },
        transactions: [
            {
                guid: "d9fb9eac-aa71-468e-b817-4d676d7cf002",
                sequence_number: 1000,
                date_of_service: "2022-07-09",
                datetime_of_service: "2022-07-09 00:00:00 EDT",
                transaction_type: "CG",
                transaction_id: 921462,
                department_code: "10040010018",
                place_of_service: "CMX",
                technical_code: {
                    units: 1,
                    code: "31000150",
                    evidence_source_uid: "b68dc456-d6cb-4a06-80bc-a21511816478",
                    confidence: 0.05,
                    used: true,
                    automated: false,
                    evidence: [
                        {
                            type: "Ngram",
                            score: 0.001863153157497147,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "<ITEM>",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 46,
                                        end: 49,
                                        level: "ngram",
                                        content: " A."
                                    },
                                    {
                                        start: 46,
                                        end: 76,
                                        level: "sentence",
                                        content: " A. Synovial fluid, left wrist"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0018320730944877644,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "bwfh",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 308,
                                        end: 312,
                                        level: "ngram",
                                        content: " BWF"
                                    },
                                    {
                                        start: 308,
                                        end: 350,
                                        level: "sentence",
                                        content: " BWFH Clinical Laboratory Number: S6099326"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0014785752932439818,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "bwfh",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 308,
                                        end: 312,
                                        level: "ngram",
                                        content: " BWF"
                                    },
                                    {
                                        start: 308,
                                        end: 350,
                                        level: "sentence",
                                        content: " BWFH Clinical Laboratory Number: S6099326"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0010624878681438782,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "admix",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 237,
                                        end: 244,
                                        level: "ngram",
                                        content: "admixed"
                                    },
                                    {
                                        start: 199,
                                        end: 270,
                                        level: "sentence",
                                        content: " No birefringent crystals identified (admixed blood limits evaluation)."
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0010528779971257847,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "electron saturday",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 398,
                                        end: 432,
                                        level: "ngram",
                                        content: " Electronically signed  on Saturda"
                                    },
                                    {
                                        start: 355,
                                        end: 462,
                                        level: "sentence",
                                        content: " Final Diagnosis by  Tad J Wieczorek M.D.,  Electronically signed  on Saturday\n July 09, 2022 at 11:17:41AM"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0009232347977570908,
                            feature: {
                                slop: 1,
                                field: "raw_body",
                                in_order: true,
                                ngram: "sign saturday",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 413,
                                        end: 432,
                                        level: "ngram",
                                        content: " signed  on Saturda"
                                    },
                                    {
                                        start: 355,
                                        end: 462,
                                        level: "sentence",
                                        content: " Final Diagnosis by  Tad J Wieczorek M.D.,  Electronically signed  on Saturday\n July 09, 2022 at 11:17:41AM"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0008588384709460938,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "admix blood",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 237,
                                        end: 250,
                                        level: "ngram",
                                        content: "admixed blood"
                                    },
                                    {
                                        start: 199,
                                        end: 270,
                                        level: "sentence",
                                        content: " No birefringent crystals identified (admixed blood limits evaluation)."
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0008588384709460938,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "time 99:99",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 295,
                                        end: 307,
                                        level: "ngram",
                                        content: " Time: 10:48"
                                    },
                                    {
                                        start: 275,
                                        end: 307,
                                        level: "sentence",
                                        content: " Collection Date and Time: 10:48"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0007478632478632476,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "evalu",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 258,
                                        end: 268,
                                        level: "ngram",
                                        content: "evaluation"
                                    },
                                    {
                                        start: 199,
                                        end: 270,
                                        level: "sentence",
                                        content: " No birefringent crystals identified (admixed blood limits evaluation)."
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0007478632478632476,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "saturday at",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 424,
                                        end: 450,
                                        level: "ngram",
                                        content: " Saturday\n July 09, 2022 a"
                                    },
                                    {
                                        start: 355,
                                        end: 462,
                                        level: "sentence",
                                        content: " Final Diagnosis by  Tad J Wieczorek M.D.,  Electronically signed  on Saturday\n July 09, 2022 at 11:17:41AM"
                                    }
                                ]
                            }
                        }
                    ]
                },
                procedure: {
                    procedure_id: null,
                    procedure_uid: null,
                    evidence_source_uid: "b68dc456-d6cb-4a06-80bc-a21511816478",
                    procedure_name: null,
                    procedure_code: "88305",
                    type: null,
                    units: 1,
                    sequence_number: null,
                    transaction_id: null,
                    automate: false,
                    confidence: 0.05,
                    evidence: [
                        {
                            type: "Ngram",
                            score: 0.001863153157497147,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "<ITEM>",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 46,
                                        end: 49,
                                        level: "ngram",
                                        content: " A."
                                    },
                                    {
                                        start: 46,
                                        end: 76,
                                        level: "sentence",
                                        content: " A. Synovial fluid, left wrist"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0018320730944877644,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "bwfh",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 308,
                                        end: 312,
                                        level: "ngram",
                                        content: " BWF"
                                    },
                                    {
                                        start: 308,
                                        end: 350,
                                        level: "sentence",
                                        content: " BWFH Clinical Laboratory Number: S6099326"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0014785752932439818,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "bwfh",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 308,
                                        end: 312,
                                        level: "ngram",
                                        content: " BWF"
                                    },
                                    {
                                        start: 308,
                                        end: 350,
                                        level: "sentence",
                                        content: " BWFH Clinical Laboratory Number: S6099326"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0010624878681438782,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "admix",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 237,
                                        end: 244,
                                        level: "ngram",
                                        content: "admixed"
                                    },
                                    {
                                        start: 199,
                                        end: 270,
                                        level: "sentence",
                                        content: " No birefringent crystals identified (admixed blood limits evaluation)."
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0010528779971257847,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "electron saturday",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 398,
                                        end: 432,
                                        level: "ngram",
                                        content: " Electronically signed  on Saturda"
                                    },
                                    {
                                        start: 355,
                                        end: 462,
                                        level: "sentence",
                                        content: " Final Diagnosis by  Tad J Wieczorek M.D.,  Electronically signed  on Saturday\n July 09, 2022 at 11:17:41AM"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0009232347977570908,
                            feature: {
                                slop: 1,
                                field: "raw_body",
                                in_order: true,
                                ngram: "sign saturday",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 413,
                                        end: 432,
                                        level: "ngram",
                                        content: " signed  on Saturda"
                                    },
                                    {
                                        start: 355,
                                        end: 462,
                                        level: "sentence",
                                        content: " Final Diagnosis by  Tad J Wieczorek M.D.,  Electronically signed  on Saturday\n July 09, 2022 at 11:17:41AM"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0008588384709460938,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "admix blood",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 237,
                                        end: 250,
                                        level: "ngram",
                                        content: "admixed blood"
                                    },
                                    {
                                        start: 199,
                                        end: 270,
                                        level: "sentence",
                                        content: " No birefringent crystals identified (admixed blood limits evaluation)."
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0008588384709460938,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "time 99:99",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 295,
                                        end: 307,
                                        level: "ngram",
                                        content: " Time: 10:48"
                                    },
                                    {
                                        start: 275,
                                        end: 307,
                                        level: "sentence",
                                        content: " Collection Date and Time: 10:48"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0007478632478632476,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "evalu",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 258,
                                        end: 268,
                                        level: "ngram",
                                        content: "evaluation"
                                    },
                                    {
                                        start: 199,
                                        end: 270,
                                        level: "sentence",
                                        content: " No birefringent crystals identified (admixed blood limits evaluation)."
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0007478632478632476,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "saturday at",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 424,
                                        end: 450,
                                        level: "ngram",
                                        content: " Saturday\n July 09, 2022 a"
                                    },
                                    {
                                        start: 355,
                                        end: 462,
                                        level: "sentence",
                                        content: " Final Diagnosis by  Tad J Wieczorek M.D.,  Electronically signed  on Saturday\n July 09, 2022 at 11:17:41AM"
                                    }
                                ]
                            }
                        }
                    ],
                    used: true
                },
                modifiers: [],
                diagnoses: [
                    {
                        diagnosis_uid: null,
                        diagnosis_code: "Z00.6",
                        evidence_source_uid: "8db88eea-d4f5-411d-9071-21da0cc788fe",
                        automate: false,
                        confidence: 0.02,
                        sequence_number: 1,
                        type: "ICD10",
                        evidence: [
                            {
                                type: "Ngram",
                                score: 0.0008736892619512791,
                                feature: {
                                    slop: 1,
                                    field: "raw_body",
                                    in_order: true,
                                    ngram: "limit evalu",
                                    type: "ngram",
                                    spans: [
                                        {
                                            start: 251,
                                            end: 268,
                                            level: "ngram",
                                            content: "limits evaluation"
                                        },
                                        {
                                            start: 199,
                                            end: 270,
                                            level: "sentence",
                                            content: " No birefringent crystals identified (admixed blood limits evaluation)."
                                        }
                                    ]
                                }
                            },
                            {
                                type: "Ngram",
                                score: 0.00042917190648663424,
                                feature: {
                                    slop: 0,
                                    field: "raw_body",
                                    in_order: true,
                                    ngram: "on",
                                    type: "ngram",
                                    spans: [
                                        {
                                            start: 421,
                                            end: 423,
                                            level: "ngram",
                                            content: " o"
                                        },
                                        {
                                            start: 355,
                                            end: 462,
                                            level: "sentence",
                                            content: " Final Diagnosis by  Tad J Wieczorek M.D.,  Electronically signed  on Saturday\n July 09, 2022 at 11:17:41AM"
                                        }
                                    ]
                                }
                            },
                            {
                                type: "Ngram",
                                score: 0.00038709150708181685,
                                feature: {
                                    slop: 0,
                                    field: "raw_body",
                                    in_order: true,
                                    ngram: "interpret no",
                                    type: "ngram",
                                    spans: [
                                        {
                                            start: 183,
                                            end: 202,
                                            level: "ngram",
                                            content: "Interpretation:\n No"
                                        },
                                        {
                                            start: 182,
                                            end: 198,
                                            level: "sentence",
                                            content: " Interpretation:"
                                        },
                                        {
                                            start: 199,
                                            end: 270,
                                            level: "sentence",
                                            content: " No birefringent crystals identified (admixed blood limits evaluation)."
                                        }
                                    ]
                                }
                            },
                            {
                                type: "Ngram",
                                score: 0.00038709150708181685,
                                feature: {
                                    slop: 0,
                                    field: "raw_body",
                                    in_order: true,
                                    ngram: "limit evalu",
                                    type: "ngram",
                                    spans: [
                                        {
                                            start: 251,
                                            end: 268,
                                            level: "ngram",
                                            content: "limits evaluation"
                                        },
                                        {
                                            start: 199,
                                            end: 270,
                                            level: "sentence",
                                            content: " No birefringent crystals identified (admixed blood limits evaluation)."
                                        }
                                    ]
                                }
                            },
                            {
                                type: "Ngram",
                                score: 0.00038709150708181685,
                                feature: {
                                    slop: 2,
                                    field: "raw_body",
                                    in_order: true,
                                    ngram: "limit evalu",
                                    type: "ngram",
                                    spans: [
                                        {
                                            start: 251,
                                            end: 268,
                                            level: "ngram",
                                            content: "limits evaluation"
                                        },
                                        {
                                            start: 199,
                                            end: 270,
                                            level: "sentence",
                                            content: " No birefringent crystals identified (admixed blood limits evaluation)."
                                        }
                                    ]
                                }
                            },
                            {
                                type: "Ngram",
                                score: 0.00038709150708181685,
                                feature: {
                                    slop: 0,
                                    field: "raw_body",
                                    in_order: true,
                                    ngram: "on saturday",
                                    type: "ngram",
                                    spans: [
                                        {
                                            start: 421,
                                            end: 432,
                                            level: "ngram",
                                            content: " on Saturda"
                                        },
                                        {
                                            start: 355,
                                            end: 462,
                                            level: "sentence",
                                            content: " Final Diagnosis by  Tad J Wieczorek M.D.,  Electronically signed  on Saturday\n July 09, 2022 at 11:17:41AM"
                                        }
                                    ]
                                }
                            },
                            {
                                type: "Ngram",
                                score: 0.0003815315415821501,
                                feature: {
                                    slop: 2,
                                    field: "raw_body",
                                    in_order: true,
                                    ngram: "identifi blood",
                                    type: "ngram",
                                    spans: [
                                        {
                                            start: 225,
                                            end: 250,
                                            level: "ngram",
                                            content: "identified (admixed blood"
                                        },
                                        {
                                            start: 199,
                                            end: 270,
                                            level: "sentence",
                                            content: " No birefringent crystals identified (admixed blood limits evaluation)."
                                        }
                                    ]
                                }
                            },
                            {
                                type: "Ngram",
                                score: 0.0003815315415821501,
                                feature: {
                                    slop: 2,
                                    field: "raw_body",
                                    in_order: true,
                                    ngram: "interpret no",
                                    type: "ngram",
                                    spans: [
                                        {
                                            start: 183,
                                            end: 202,
                                            level: "ngram",
                                            content: "Interpretation:\n No"
                                        },
                                        {
                                            start: 182,
                                            end: 198,
                                            level: "sentence",
                                            content: " Interpretation:"
                                        },
                                        {
                                            start: 199,
                                            end: 270,
                                            level: "sentence",
                                            content: " No birefringent crystals identified (admixed blood limits evaluation)."
                                        }
                                    ]
                                }
                            },
                            {
                                type: "Ngram",
                                score: 0.000005559965499666767,
                                feature: {
                                    slop: 1,
                                    field: "raw_body",
                                    in_order: true,
                                    ngram: "identifi blood",
                                    type: "ngram",
                                    spans: [
                                        {
                                            start: 225,
                                            end: 250,
                                            level: "ngram",
                                            content: "identified (admixed blood"
                                        },
                                        {
                                            start: 199,
                                            end: 270,
                                            level: "sentence",
                                            content: " No birefringent crystals identified (admixed blood limits evaluation)."
                                        }
                                    ]
                                }
                            },
                            {
                                type: "Ngram",
                                score: 0.000005559965499666767,
                                feature: {
                                    slop: 1,
                                    field: "raw_body",
                                    in_order: true,
                                    ngram: "interpret no",
                                    type: "ngram",
                                    spans: [
                                        {
                                            start: 183,
                                            end: 202,
                                            level: "ngram",
                                            content: "Interpretation:\n No"
                                        },
                                        {
                                            start: 182,
                                            end: 198,
                                            level: "sentence",
                                            content: " Interpretation:"
                                        },
                                        {
                                            start: 199,
                                            end: 270,
                                            level: "sentence",
                                            content: " No birefringent crystals identified (admixed blood limits evaluation)."
                                        }
                                    ]
                                }
                            }
                        ],
                        used: true
                    }
                ]
            }
        ]
    },
    {
        type: "PROCESSED",
        guid: "b157da0f-9c17-4674-9585-e1d38d37e47c",
        billing_type: "BWF PATHOLOGY LAB",
        charge_code_type: "Split",
        patient_type: "",
        filler_number: {
            number: "FCP-22-N00335",
            issuer: "EPIC",
            type: "SPECIMEN_NUMBER"
        },
        billing_provider_number: {
            number: "1004910",
            issuer: "EPIC",
            type: "IDNO"
        },
        ordering_provider_number: {
            number: "1004910",
            issuer: "EPIC",
            type: "IDNO"
        },
        performing_provider_number: {
            number: "1004910",
            issuer: "EPIC",
            type: "IDNO"
        },
        transactions: [
            {
                guid: "0bae6a0c-e659-48fb-96ff-7aba125bfcf3",
                sequence_number: 1000,
                date_of_service: "2022-07-09",
                datetime_of_service: "2022-07-09 00:00:00 EDT",
                transaction_type: "CG",
                transaction_id: 921552,
                department_code: "10040010018",
                place_of_service: "CMX",
                technical_code: {
                    units: 1,
                    code: "31000150",
                    evidence_source_uid: "b68dc456-d6cb-4a06-80bc-a21511816478",
                    confidence: 0.05,
                    used: true,
                    automated: false,
                    evidence: [
                        {
                            type: "Ngram",
                            score: 0.001863153157497147,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "<ITEM>",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 46,
                                        end: 49,
                                        level: "ngram",
                                        content: " A."
                                    },
                                    {
                                        start: 46,
                                        end: 76,
                                        level: "sentence",
                                        content: " A. Synovial fluid, left wrist"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0018320730944877644,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "bwfh",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 308,
                                        end: 312,
                                        level: "ngram",
                                        content: " BWF"
                                    },
                                    {
                                        start: 308,
                                        end: 350,
                                        level: "sentence",
                                        content: " BWFH Clinical Laboratory Number: S6099326"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0014785752932439818,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "bwfh",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 308,
                                        end: 312,
                                        level: "ngram",
                                        content: " BWF"
                                    },
                                    {
                                        start: 308,
                                        end: 350,
                                        level: "sentence",
                                        content: " BWFH Clinical Laboratory Number: S6099326"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0010624878681438782,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "admix",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 237,
                                        end: 244,
                                        level: "ngram",
                                        content: "admixed"
                                    },
                                    {
                                        start: 199,
                                        end: 270,
                                        level: "sentence",
                                        content: " No birefringent crystals identified (admixed blood limits evaluation)."
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0010528779971257847,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "electron saturday",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 398,
                                        end: 432,
                                        level: "ngram",
                                        content: " Electronically signed  on Saturda"
                                    },
                                    {
                                        start: 355,
                                        end: 462,
                                        level: "sentence",
                                        content: " Final Diagnosis by  Tad J Wieczorek M.D.,  Electronically signed  on Saturday\n July 09, 2022 at 11:17:41AM"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0009232347977570908,
                            feature: {
                                slop: 1,
                                field: "raw_body",
                                in_order: true,
                                ngram: "sign saturday",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 413,
                                        end: 432,
                                        level: "ngram",
                                        content: " signed  on Saturda"
                                    },
                                    {
                                        start: 355,
                                        end: 462,
                                        level: "sentence",
                                        content: " Final Diagnosis by  Tad J Wieczorek M.D.,  Electronically signed  on Saturday\n July 09, 2022 at 11:17:41AM"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0008588384709460938,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "admix blood",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 237,
                                        end: 250,
                                        level: "ngram",
                                        content: "admixed blood"
                                    },
                                    {
                                        start: 199,
                                        end: 270,
                                        level: "sentence",
                                        content: " No birefringent crystals identified (admixed blood limits evaluation)."
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0008588384709460938,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "time 99:99",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 295,
                                        end: 307,
                                        level: "ngram",
                                        content: " Time: 10:48"
                                    },
                                    {
                                        start: 275,
                                        end: 307,
                                        level: "sentence",
                                        content: " Collection Date and Time: 10:48"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0007478632478632476,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "evalu",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 258,
                                        end: 268,
                                        level: "ngram",
                                        content: "evaluation"
                                    },
                                    {
                                        start: 199,
                                        end: 270,
                                        level: "sentence",
                                        content: " No birefringent crystals identified (admixed blood limits evaluation)."
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0007478632478632476,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "saturday at",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 424,
                                        end: 450,
                                        level: "ngram",
                                        content: " Saturday\n July 09, 2022 a"
                                    },
                                    {
                                        start: 355,
                                        end: 462,
                                        level: "sentence",
                                        content: " Final Diagnosis by  Tad J Wieczorek M.D.,  Electronically signed  on Saturday\n July 09, 2022 at 11:17:41AM"
                                    }
                                ]
                            }
                        }
                    ]
                },
                procedure: {
                    procedure_id: null,
                    procedure_uid: null,
                    evidence_source_uid: "b68dc456-d6cb-4a06-80bc-a21511816478",
                    procedure_name: null,
                    procedure_code: "88305",
                    type: null,
                    units: 1,
                    sequence_number: null,
                    transaction_id: null,
                    automate: false,
                    confidence: 0.05,
                    evidence: [
                        {
                            type: "Ngram",
                            score: 0.001863153157497147,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "<ITEM>",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 46,
                                        end: 49,
                                        level: "ngram",
                                        content: " A."
                                    },
                                    {
                                        start: 46,
                                        end: 76,
                                        level: "sentence",
                                        content: " A. Synovial fluid, left wrist"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0018320730944877644,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "bwfh",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 308,
                                        end: 312,
                                        level: "ngram",
                                        content: " BWF"
                                    },
                                    {
                                        start: 308,
                                        end: 350,
                                        level: "sentence",
                                        content: " BWFH Clinical Laboratory Number: S6099326"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0014785752932439818,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "bwfh",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 308,
                                        end: 312,
                                        level: "ngram",
                                        content: " BWF"
                                    },
                                    {
                                        start: 308,
                                        end: 350,
                                        level: "sentence",
                                        content: " BWFH Clinical Laboratory Number: S6099326"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0010624878681438782,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "admix",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 237,
                                        end: 244,
                                        level: "ngram",
                                        content: "admixed"
                                    },
                                    {
                                        start: 199,
                                        end: 270,
                                        level: "sentence",
                                        content: " No birefringent crystals identified (admixed blood limits evaluation)."
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0010528779971257847,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "electron saturday",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 398,
                                        end: 432,
                                        level: "ngram",
                                        content: " Electronically signed  on Saturda"
                                    },
                                    {
                                        start: 355,
                                        end: 462,
                                        level: "sentence",
                                        content: " Final Diagnosis by  Tad J Wieczorek M.D.,  Electronically signed  on Saturday\n July 09, 2022 at 11:17:41AM"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0009232347977570908,
                            feature: {
                                slop: 1,
                                field: "raw_body",
                                in_order: true,
                                ngram: "sign saturday",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 413,
                                        end: 432,
                                        level: "ngram",
                                        content: " signed  on Saturda"
                                    },
                                    {
                                        start: 355,
                                        end: 462,
                                        level: "sentence",
                                        content: " Final Diagnosis by  Tad J Wieczorek M.D.,  Electronically signed  on Saturday\n July 09, 2022 at 11:17:41AM"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0008588384709460938,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "admix blood",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 237,
                                        end: 250,
                                        level: "ngram",
                                        content: "admixed blood"
                                    },
                                    {
                                        start: 199,
                                        end: 270,
                                        level: "sentence",
                                        content: " No birefringent crystals identified (admixed blood limits evaluation)."
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0008588384709460938,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "time 99:99",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 295,
                                        end: 307,
                                        level: "ngram",
                                        content: " Time: 10:48"
                                    },
                                    {
                                        start: 275,
                                        end: 307,
                                        level: "sentence",
                                        content: " Collection Date and Time: 10:48"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0007478632478632476,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "evalu",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 258,
                                        end: 268,
                                        level: "ngram",
                                        content: "evaluation"
                                    },
                                    {
                                        start: 199,
                                        end: 270,
                                        level: "sentence",
                                        content: " No birefringent crystals identified (admixed blood limits evaluation)."
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0007478632478632476,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "saturday at",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 424,
                                        end: 450,
                                        level: "ngram",
                                        content: " Saturday\n July 09, 2022 a"
                                    },
                                    {
                                        start: 355,
                                        end: 462,
                                        level: "sentence",
                                        content: " Final Diagnosis by  Tad J Wieczorek M.D.,  Electronically signed  on Saturday\n July 09, 2022 at 11:17:41AM"
                                    }
                                ]
                            }
                        }
                    ],
                    used: true
                },
                modifiers: [],
                diagnoses: [
                    {
                        diagnosis_uid: null,
                        diagnosis_code: "Z00.6",
                        evidence_source_uid: "8db88eea-d4f5-411d-9071-21da0cc788fe",
                        automate: false,
                        confidence: 0.02,
                        sequence_number: 1,
                        type: "ICD10",
                        evidence: [
                            {
                                type: "Ngram",
                                score: 0.0008736892619512791,
                                feature: {
                                    slop: 1,
                                    field: "raw_body",
                                    in_order: true,
                                    ngram: "limit evalu",
                                    type: "ngram",
                                    spans: [
                                        {
                                            start: 251,
                                            end: 268,
                                            level: "ngram",
                                            content: "limits evaluation"
                                        },
                                        {
                                            start: 199,
                                            end: 270,
                                            level: "sentence",
                                            content: " No birefringent crystals identified (admixed blood limits evaluation)."
                                        }
                                    ]
                                }
                            },
                            {
                                type: "Ngram",
                                score: 0.00042917190648663424,
                                feature: {
                                    slop: 0,
                                    field: "raw_body",
                                    in_order: true,
                                    ngram: "on",
                                    type: "ngram",
                                    spans: [
                                        {
                                            start: 421,
                                            end: 423,
                                            level: "ngram",
                                            content: " o"
                                        },
                                        {
                                            start: 355,
                                            end: 462,
                                            level: "sentence",
                                            content: " Final Diagnosis by  Tad J Wieczorek M.D.,  Electronically signed  on Saturday\n July 09, 2022 at 11:17:41AM"
                                        }
                                    ]
                                }
                            },
                            {
                                type: "Ngram",
                                score: 0.00038709150708181685,
                                feature: {
                                    slop: 0,
                                    field: "raw_body",
                                    in_order: true,
                                    ngram: "interpret no",
                                    type: "ngram",
                                    spans: [
                                        {
                                            start: 183,
                                            end: 202,
                                            level: "ngram",
                                            content: "Interpretation:\n No"
                                        },
                                        {
                                            start: 182,
                                            end: 198,
                                            level: "sentence",
                                            content: " Interpretation:"
                                        },
                                        {
                                            start: 199,
                                            end: 270,
                                            level: "sentence",
                                            content: " No birefringent crystals identified (admixed blood limits evaluation)."
                                        }
                                    ]
                                }
                            },
                            {
                                type: "Ngram",
                                score: 0.00038709150708181685,
                                feature: {
                                    slop: 0,
                                    field: "raw_body",
                                    in_order: true,
                                    ngram: "limit evalu",
                                    type: "ngram",
                                    spans: [
                                        {
                                            start: 251,
                                            end: 268,
                                            level: "ngram",
                                            content: "limits evaluation"
                                        },
                                        {
                                            start: 199,
                                            end: 270,
                                            level: "sentence",
                                            content: " No birefringent crystals identified (admixed blood limits evaluation)."
                                        }
                                    ]
                                }
                            },
                            {
                                type: "Ngram",
                                score: 0.00038709150708181685,
                                feature: {
                                    slop: 2,
                                    field: "raw_body",
                                    in_order: true,
                                    ngram: "limit evalu",
                                    type: "ngram",
                                    spans: [
                                        {
                                            start: 251,
                                            end: 268,
                                            level: "ngram",
                                            content: "limits evaluation"
                                        },
                                        {
                                            start: 199,
                                            end: 270,
                                            level: "sentence",
                                            content: " No birefringent crystals identified (admixed blood limits evaluation)."
                                        }
                                    ]
                                }
                            },
                            {
                                type: "Ngram",
                                score: 0.00038709150708181685,
                                feature: {
                                    slop: 0,
                                    field: "raw_body",
                                    in_order: true,
                                    ngram: "on saturday",
                                    type: "ngram",
                                    spans: [
                                        {
                                            start: 421,
                                            end: 432,
                                            level: "ngram",
                                            content: " on Saturda"
                                        },
                                        {
                                            start: 355,
                                            end: 462,
                                            level: "sentence",
                                            content: " Final Diagnosis by  Tad J Wieczorek M.D.,  Electronically signed  on Saturday\n July 09, 2022 at 11:17:41AM"
                                        }
                                    ]
                                }
                            },
                            {
                                type: "Ngram",
                                score: 0.0003815315415821501,
                                feature: {
                                    slop: 2,
                                    field: "raw_body",
                                    in_order: true,
                                    ngram: "identifi blood",
                                    type: "ngram",
                                    spans: [
                                        {
                                            start: 225,
                                            end: 250,
                                            level: "ngram",
                                            content: "identified (admixed blood"
                                        },
                                        {
                                            start: 199,
                                            end: 270,
                                            level: "sentence",
                                            content: " No birefringent crystals identified (admixed blood limits evaluation)."
                                        }
                                    ]
                                }
                            },
                            {
                                type: "Ngram",
                                score: 0.0003815315415821501,
                                feature: {
                                    slop: 2,
                                    field: "raw_body",
                                    in_order: true,
                                    ngram: "interpret no",
                                    type: "ngram",
                                    spans: [
                                        {
                                            start: 183,
                                            end: 202,
                                            level: "ngram",
                                            content: "Interpretation:\n No"
                                        },
                                        {
                                            start: 182,
                                            end: 198,
                                            level: "sentence",
                                            content: " Interpretation:"
                                        },
                                        {
                                            start: 199,
                                            end: 270,
                                            level: "sentence",
                                            content: " No birefringent crystals identified (admixed blood limits evaluation)."
                                        }
                                    ]
                                }
                            },
                            {
                                type: "Ngram",
                                score: 0.000005559965499666767,
                                feature: {
                                    slop: 1,
                                    field: "raw_body",
                                    in_order: true,
                                    ngram: "identifi blood",
                                    type: "ngram",
                                    spans: [
                                        {
                                            start: 225,
                                            end: 250,
                                            level: "ngram",
                                            content: "identified (admixed blood"
                                        },
                                        {
                                            start: 199,
                                            end: 270,
                                            level: "sentence",
                                            content: " No birefringent crystals identified (admixed blood limits evaluation)."
                                        }
                                    ]
                                }
                            },
                            {
                                type: "Ngram",
                                score: 0.000005559965499666767,
                                feature: {
                                    slop: 1,
                                    field: "raw_body",
                                    in_order: true,
                                    ngram: "interpret no",
                                    type: "ngram",
                                    spans: [
                                        {
                                            start: 183,
                                            end: 202,
                                            level: "ngram",
                                            content: "Interpretation:\n No"
                                        },
                                        {
                                            start: 182,
                                            end: 198,
                                            level: "sentence",
                                            content: " Interpretation:"
                                        },
                                        {
                                            start: 199,
                                            end: 270,
                                            level: "sentence",
                                            content: " No birefringent crystals identified (admixed blood limits evaluation)."
                                        }
                                    ]
                                }
                            }
                        ],
                        used: true
                    }
                ]
            }
        ]
    },
    {
        type: "SUBMITTED",
        guid: "f48d5fd5-eb73-44cf-baf0-681bc0355dd8",
        billing_type: "BWF PATHOLOGY LAB",
        charge_code_type: "Split",
        patient_type: "",
        filler_number: {
            number: "FCP-22-N00335",
            issuer: "EPIC",
            type: "SPECIMEN_NUMBER"
        },
        billing_provider_number: {
            number: "1004910",
            issuer: "EPIC",
            type: "IDNO"
        },
        ordering_provider_number: {
            number: "1004910",
            issuer: "EPIC",
            type: "IDNO"
        },
        performing_provider_number: {
            number: "1004910",
            issuer: "EPIC",
            type: "IDNO"
        },
        transactions: [
            {
                guid: "f91d107d-98ad-47be-b2ed-e1fc4387b665",
                sequence_number: 1000,
                type: "PB",
                date_of_service: "2022-07-09",
                datetime_of_service: "2022-07-09 00:00:00 EDT",
                transaction_type: "CG",
                transaction_id: 921574,
                department_code: "10040010018",
                place_of_service: "CMX",
                procedure: {
                    procedure_id: null,
                    procedure_uid: null,
                    evidence_source_uid: "b68dc456-d6cb-4a06-80bc-a21511816478",
                    procedure_name: null,
                    procedure_code: "88305",
                    type: null,
                    units: 1,
                    sequence_number: null,
                    transaction_id: null,
                    automate: false,
                    confidence: 0.05,
                    evidence: [
                        {
                            type: "Ngram",
                            score: 0.001863153157497147,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "<ITEM>",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 46,
                                        end: 49,
                                        level: "ngram",
                                        content: " A."
                                    },
                                    {
                                        start: 46,
                                        end: 76,
                                        level: "sentence",
                                        content: " A. Synovial fluid, left wrist"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0018320730944877644,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "bwfh",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 308,
                                        end: 312,
                                        level: "ngram",
                                        content: " BWF"
                                    },
                                    {
                                        start: 308,
                                        end: 350,
                                        level: "sentence",
                                        content: " BWFH Clinical Laboratory Number: S6099326"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0014785752932439818,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "bwfh",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 308,
                                        end: 312,
                                        level: "ngram",
                                        content: " BWF"
                                    },
                                    {
                                        start: 308,
                                        end: 350,
                                        level: "sentence",
                                        content: " BWFH Clinical Laboratory Number: S6099326"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0010624878681438782,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "admix",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 237,
                                        end: 244,
                                        level: "ngram",
                                        content: "admixed"
                                    },
                                    {
                                        start: 199,
                                        end: 270,
                                        level: "sentence",
                                        content: " No birefringent crystals identified (admixed blood limits evaluation)."
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0010528779971257847,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "electron saturday",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 398,
                                        end: 432,
                                        level: "ngram",
                                        content: " Electronically signed  on Saturda"
                                    },
                                    {
                                        start: 355,
                                        end: 462,
                                        level: "sentence",
                                        content: " Final Diagnosis by  Tad J Wieczorek M.D.,  Electronically signed  on Saturday\n July 09, 2022 at 11:17:41AM"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0009232347977570908,
                            feature: {
                                slop: 1,
                                field: "raw_body",
                                in_order: true,
                                ngram: "sign saturday",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 413,
                                        end: 432,
                                        level: "ngram",
                                        content: " signed  on Saturda"
                                    },
                                    {
                                        start: 355,
                                        end: 462,
                                        level: "sentence",
                                        content: " Final Diagnosis by  Tad J Wieczorek M.D.,  Electronically signed  on Saturday\n July 09, 2022 at 11:17:41AM"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0008588384709460938,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "admix blood",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 237,
                                        end: 250,
                                        level: "ngram",
                                        content: "admixed blood"
                                    },
                                    {
                                        start: 199,
                                        end: 270,
                                        level: "sentence",
                                        content: " No birefringent crystals identified (admixed blood limits evaluation)."
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0008588384709460938,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "time 99:99",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 295,
                                        end: 307,
                                        level: "ngram",
                                        content: " Time: 10:48"
                                    },
                                    {
                                        start: 275,
                                        end: 307,
                                        level: "sentence",
                                        content: " Collection Date and Time: 10:48"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0007478632478632476,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "evalu",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 258,
                                        end: 268,
                                        level: "ngram",
                                        content: "evaluation"
                                    },
                                    {
                                        start: 199,
                                        end: 270,
                                        level: "sentence",
                                        content: " No birefringent crystals identified (admixed blood limits evaluation)."
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0007478632478632476,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "saturday at",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 424,
                                        end: 450,
                                        level: "ngram",
                                        content: " Saturday\n July 09, 2022 a"
                                    },
                                    {
                                        start: 355,
                                        end: 462,
                                        level: "sentence",
                                        content: " Final Diagnosis by  Tad J Wieczorek M.D.,  Electronically signed  on Saturday\n July 09, 2022 at 11:17:41AM"
                                    }
                                ]
                            }
                        }
                    ],
                    used: true
                },
                modifiers: [],
                diagnoses: [
                    {
                        diagnosis_uid: null,
                        diagnosis_code: "Z00.6",
                        evidence_source_uid: "8db88eea-d4f5-411d-9071-21da0cc788fe",
                        automate: false,
                        confidence: 0.02,
                        sequence_number: 1,
                        type: "ICD10",
                        evidence: [
                            {
                                type: "Ngram",
                                score: 0.0008736892619512791,
                                feature: {
                                    slop: 1,
                                    field: "raw_body",
                                    in_order: true,
                                    ngram: "limit evalu",
                                    type: "ngram",
                                    spans: [
                                        {
                                            start: 251,
                                            end: 268,
                                            level: "ngram",
                                            content: "limits evaluation"
                                        },
                                        {
                                            start: 199,
                                            end: 270,
                                            level: "sentence",
                                            content: " No birefringent crystals identified (admixed blood limits evaluation)."
                                        }
                                    ]
                                }
                            },
                            {
                                type: "Ngram",
                                score: 0.00042917190648663424,
                                feature: {
                                    slop: 0,
                                    field: "raw_body",
                                    in_order: true,
                                    ngram: "on",
                                    type: "ngram",
                                    spans: [
                                        {
                                            start: 421,
                                            end: 423,
                                            level: "ngram",
                                            content: " o"
                                        },
                                        {
                                            start: 355,
                                            end: 462,
                                            level: "sentence",
                                            content: " Final Diagnosis by  Tad J Wieczorek M.D.,  Electronically signed  on Saturday\n July 09, 2022 at 11:17:41AM"
                                        }
                                    ]
                                }
                            },
                            {
                                type: "Ngram",
                                score: 0.00038709150708181685,
                                feature: {
                                    slop: 0,
                                    field: "raw_body",
                                    in_order: true,
                                    ngram: "interpret no",
                                    type: "ngram",
                                    spans: [
                                        {
                                            start: 183,
                                            end: 202,
                                            level: "ngram",
                                            content: "Interpretation:\n No"
                                        },
                                        {
                                            start: 182,
                                            end: 198,
                                            level: "sentence",
                                            content: " Interpretation:"
                                        },
                                        {
                                            start: 199,
                                            end: 270,
                                            level: "sentence",
                                            content: " No birefringent crystals identified (admixed blood limits evaluation)."
                                        }
                                    ]
                                }
                            },
                            {
                                type: "Ngram",
                                score: 0.00038709150708181685,
                                feature: {
                                    slop: 0,
                                    field: "raw_body",
                                    in_order: true,
                                    ngram: "limit evalu",
                                    type: "ngram",
                                    spans: [
                                        {
                                            start: 251,
                                            end: 268,
                                            level: "ngram",
                                            content: "limits evaluation"
                                        },
                                        {
                                            start: 199,
                                            end: 270,
                                            level: "sentence",
                                            content: " No birefringent crystals identified (admixed blood limits evaluation)."
                                        }
                                    ]
                                }
                            },
                            {
                                type: "Ngram",
                                score: 0.00038709150708181685,
                                feature: {
                                    slop: 2,
                                    field: "raw_body",
                                    in_order: true,
                                    ngram: "limit evalu",
                                    type: "ngram",
                                    spans: [
                                        {
                                            start: 251,
                                            end: 268,
                                            level: "ngram",
                                            content: "limits evaluation"
                                        },
                                        {
                                            start: 199,
                                            end: 270,
                                            level: "sentence",
                                            content: " No birefringent crystals identified (admixed blood limits evaluation)."
                                        }
                                    ]
                                }
                            },
                            {
                                type: "Ngram",
                                score: 0.00038709150708181685,
                                feature: {
                                    slop: 0,
                                    field: "raw_body",
                                    in_order: true,
                                    ngram: "on saturday",
                                    type: "ngram",
                                    spans: [
                                        {
                                            start: 421,
                                            end: 432,
                                            level: "ngram",
                                            content: " on Saturda"
                                        },
                                        {
                                            start: 355,
                                            end: 462,
                                            level: "sentence",
                                            content: " Final Diagnosis by  Tad J Wieczorek M.D.,  Electronically signed  on Saturday\n July 09, 2022 at 11:17:41AM"
                                        }
                                    ]
                                }
                            },
                            {
                                type: "Ngram",
                                score: 0.0003815315415821501,
                                feature: {
                                    slop: 2,
                                    field: "raw_body",
                                    in_order: true,
                                    ngram: "identifi blood",
                                    type: "ngram",
                                    spans: [
                                        {
                                            start: 225,
                                            end: 250,
                                            level: "ngram",
                                            content: "identified (admixed blood"
                                        },
                                        {
                                            start: 199,
                                            end: 270,
                                            level: "sentence",
                                            content: " No birefringent crystals identified (admixed blood limits evaluation)."
                                        }
                                    ]
                                }
                            },
                            {
                                type: "Ngram",
                                score: 0.0003815315415821501,
                                feature: {
                                    slop: 2,
                                    field: "raw_body",
                                    in_order: true,
                                    ngram: "interpret no",
                                    type: "ngram",
                                    spans: [
                                        {
                                            start: 183,
                                            end: 202,
                                            level: "ngram",
                                            content: "Interpretation:\n No"
                                        },
                                        {
                                            start: 182,
                                            end: 198,
                                            level: "sentence",
                                            content: " Interpretation:"
                                        },
                                        {
                                            start: 199,
                                            end: 270,
                                            level: "sentence",
                                            content: " No birefringent crystals identified (admixed blood limits evaluation)."
                                        }
                                    ]
                                }
                            },
                            {
                                type: "Ngram",
                                score: 0.000005559965499666767,
                                feature: {
                                    slop: 1,
                                    field: "raw_body",
                                    in_order: true,
                                    ngram: "identifi blood",
                                    type: "ngram",
                                    spans: [
                                        {
                                            start: 225,
                                            end: 250,
                                            level: "ngram",
                                            content: "identified (admixed blood"
                                        },
                                        {
                                            start: 199,
                                            end: 270,
                                            level: "sentence",
                                            content: " No birefringent crystals identified (admixed blood limits evaluation)."
                                        }
                                    ]
                                }
                            },
                            {
                                type: "Ngram",
                                score: 0.000005559965499666767,
                                feature: {
                                    slop: 1,
                                    field: "raw_body",
                                    in_order: true,
                                    ngram: "interpret no",
                                    type: "ngram",
                                    spans: [
                                        {
                                            start: 183,
                                            end: 202,
                                            level: "ngram",
                                            content: "Interpretation:\n No"
                                        },
                                        {
                                            start: 182,
                                            end: 198,
                                            level: "sentence",
                                            content: " Interpretation:"
                                        },
                                        {
                                            start: 199,
                                            end: 270,
                                            level: "sentence",
                                            content: " No birefringent crystals identified (admixed blood limits evaluation)."
                                        }
                                    ]
                                }
                            }
                        ],
                        used: true
                    }
                ]
            },
            {
                guid: "0c8d7ac8-c25b-4e58-a6be-e15c590ce4f5",
                sequence_number: 1001,
                type: "HB",
                date_of_service: "2022-07-09",
                datetime_of_service: "2022-07-09 00:00:00 EDT",
                transaction_type: "CG",
                transaction_id: 921575,
                department_code: "10040010018",
                place_of_service: "CMX",
                technical_code: {
                    units: 1,
                    code: "31000150",
                    evidence_source_uid: "b68dc456-d6cb-4a06-80bc-a21511816478",
                    confidence: 0.05,
                    used: true,
                    automated: false,
                    evidence: [
                        {
                            type: "Ngram",
                            score: 0.001863153157497147,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "<ITEM>",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 46,
                                        end: 49,
                                        level: "ngram",
                                        content: " A."
                                    },
                                    {
                                        start: 46,
                                        end: 76,
                                        level: "sentence",
                                        content: " A. Synovial fluid, left wrist"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0018320730944877644,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "bwfh",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 308,
                                        end: 312,
                                        level: "ngram",
                                        content: " BWF"
                                    },
                                    {
                                        start: 308,
                                        end: 350,
                                        level: "sentence",
                                        content: " BWFH Clinical Laboratory Number: S6099326"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0014785752932439818,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "bwfh",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 308,
                                        end: 312,
                                        level: "ngram",
                                        content: " BWF"
                                    },
                                    {
                                        start: 308,
                                        end: 350,
                                        level: "sentence",
                                        content: " BWFH Clinical Laboratory Number: S6099326"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0010624878681438782,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "admix",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 237,
                                        end: 244,
                                        level: "ngram",
                                        content: "admixed"
                                    },
                                    {
                                        start: 199,
                                        end: 270,
                                        level: "sentence",
                                        content: " No birefringent crystals identified (admixed blood limits evaluation)."
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0010528779971257847,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "electron saturday",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 398,
                                        end: 432,
                                        level: "ngram",
                                        content: " Electronically signed  on Saturda"
                                    },
                                    {
                                        start: 355,
                                        end: 462,
                                        level: "sentence",
                                        content: " Final Diagnosis by  Tad J Wieczorek M.D.,  Electronically signed  on Saturday\n July 09, 2022 at 11:17:41AM"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0009232347977570908,
                            feature: {
                                slop: 1,
                                field: "raw_body",
                                in_order: true,
                                ngram: "sign saturday",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 413,
                                        end: 432,
                                        level: "ngram",
                                        content: " signed  on Saturda"
                                    },
                                    {
                                        start: 355,
                                        end: 462,
                                        level: "sentence",
                                        content: " Final Diagnosis by  Tad J Wieczorek M.D.,  Electronically signed  on Saturday\n July 09, 2022 at 11:17:41AM"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0008588384709460938,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "admix blood",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 237,
                                        end: 250,
                                        level: "ngram",
                                        content: "admixed blood"
                                    },
                                    {
                                        start: 199,
                                        end: 270,
                                        level: "sentence",
                                        content: " No birefringent crystals identified (admixed blood limits evaluation)."
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0008588384709460938,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "time 99:99",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 295,
                                        end: 307,
                                        level: "ngram",
                                        content: " Time: 10:48"
                                    },
                                    {
                                        start: 275,
                                        end: 307,
                                        level: "sentence",
                                        content: " Collection Date and Time: 10:48"
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0007478632478632476,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "evalu",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 258,
                                        end: 268,
                                        level: "ngram",
                                        content: "evaluation"
                                    },
                                    {
                                        start: 199,
                                        end: 270,
                                        level: "sentence",
                                        content: " No birefringent crystals identified (admixed blood limits evaluation)."
                                    }
                                ]
                            }
                        },
                        {
                            type: "Ngram",
                            score: 0.0007478632478632476,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "saturday at",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 424,
                                        end: 450,
                                        level: "ngram",
                                        content: " Saturday\n July 09, 2022 a"
                                    },
                                    {
                                        start: 355,
                                        end: 462,
                                        level: "sentence",
                                        content: " Final Diagnosis by  Tad J Wieczorek M.D.,  Electronically signed  on Saturday\n July 09, 2022 at 11:17:41AM"
                                    }
                                ]
                            }
                        }
                    ]
                },
                modifiers: [],
                diagnoses: [
                    {
                        diagnosis_uid: null,
                        diagnosis_code: "Z00.6",
                        evidence_source_uid: "8db88eea-d4f5-411d-9071-21da0cc788fe",
                        automate: false,
                        confidence: 0.02,
                        sequence_number: 1,
                        type: "ICD10",
                        evidence: [
                            {
                                type: "Ngram",
                                score: 0.0008736892619512791,
                                feature: {
                                    slop: 1,
                                    field: "raw_body",
                                    in_order: true,
                                    ngram: "limit evalu",
                                    type: "ngram",
                                    spans: [
                                        {
                                            start: 251,
                                            end: 268,
                                            level: "ngram",
                                            content: "limits evaluation"
                                        },
                                        {
                                            start: 199,
                                            end: 270,
                                            level: "sentence",
                                            content: " No birefringent crystals identified (admixed blood limits evaluation)."
                                        }
                                    ]
                                }
                            },
                            {
                                type: "Ngram",
                                score: 0.00042917190648663424,
                                feature: {
                                    slop: 0,
                                    field: "raw_body",
                                    in_order: true,
                                    ngram: "on",
                                    type: "ngram",
                                    spans: [
                                        {
                                            start: 421,
                                            end: 423,
                                            level: "ngram",
                                            content: " o"
                                        },
                                        {
                                            start: 355,
                                            end: 462,
                                            level: "sentence",
                                            content: " Final Diagnosis by  Tad J Wieczorek M.D.,  Electronically signed  on Saturday\n July 09, 2022 at 11:17:41AM"
                                        }
                                    ]
                                }
                            },
                            {
                                type: "Ngram",
                                score: 0.00038709150708181685,
                                feature: {
                                    slop: 0,
                                    field: "raw_body",
                                    in_order: true,
                                    ngram: "interpret no",
                                    type: "ngram",
                                    spans: [
                                        {
                                            start: 183,
                                            end: 202,
                                            level: "ngram",
                                            content: "Interpretation:\n No"
                                        },
                                        {
                                            start: 182,
                                            end: 198,
                                            level: "sentence",
                                            content: " Interpretation:"
                                        },
                                        {
                                            start: 199,
                                            end: 270,
                                            level: "sentence",
                                            content: " No birefringent crystals identified (admixed blood limits evaluation)."
                                        }
                                    ]
                                }
                            },
                            {
                                type: "Ngram",
                                score: 0.00038709150708181685,
                                feature: {
                                    slop: 0,
                                    field: "raw_body",
                                    in_order: true,
                                    ngram: "limit evalu",
                                    type: "ngram",
                                    spans: [
                                        {
                                            start: 251,
                                            end: 268,
                                            level: "ngram",
                                            content: "limits evaluation"
                                        },
                                        {
                                            start: 199,
                                            end: 270,
                                            level: "sentence",
                                            content: " No birefringent crystals identified (admixed blood limits evaluation)."
                                        }
                                    ]
                                }
                            },
                            {
                                type: "Ngram",
                                score: 0.00038709150708181685,
                                feature: {
                                    slop: 2,
                                    field: "raw_body",
                                    in_order: true,
                                    ngram: "limit evalu",
                                    type: "ngram",
                                    spans: [
                                        {
                                            start: 251,
                                            end: 268,
                                            level: "ngram",
                                            content: "limits evaluation"
                                        },
                                        {
                                            start: 199,
                                            end: 270,
                                            level: "sentence",
                                            content: " No birefringent crystals identified (admixed blood limits evaluation)."
                                        }
                                    ]
                                }
                            },
                            {
                                type: "Ngram",
                                score: 0.00038709150708181685,
                                feature: {
                                    slop: 0,
                                    field: "raw_body",
                                    in_order: true,
                                    ngram: "on saturday",
                                    type: "ngram",
                                    spans: [
                                        {
                                            start: 421,
                                            end: 432,
                                            level: "ngram",
                                            content: " on Saturda"
                                        },
                                        {
                                            start: 355,
                                            end: 462,
                                            level: "sentence",
                                            content: " Final Diagnosis by  Tad J Wieczorek M.D.,  Electronically signed  on Saturday\n July 09, 2022 at 11:17:41AM"
                                        }
                                    ]
                                }
                            },
                            {
                                type: "Ngram",
                                score: 0.0003815315415821501,
                                feature: {
                                    slop: 2,
                                    field: "raw_body",
                                    in_order: true,
                                    ngram: "identifi blood",
                                    type: "ngram",
                                    spans: [
                                        {
                                            start: 225,
                                            end: 250,
                                            level: "ngram",
                                            content: "identified (admixed blood"
                                        },
                                        {
                                            start: 199,
                                            end: 270,
                                            level: "sentence",
                                            content: " No birefringent crystals identified (admixed blood limits evaluation)."
                                        }
                                    ]
                                }
                            },
                            {
                                type: "Ngram",
                                score: 0.0003815315415821501,
                                feature: {
                                    slop: 2,
                                    field: "raw_body",
                                    in_order: true,
                                    ngram: "interpret no",
                                    type: "ngram",
                                    spans: [
                                        {
                                            start: 183,
                                            end: 202,
                                            level: "ngram",
                                            content: "Interpretation:\n No"
                                        },
                                        {
                                            start: 182,
                                            end: 198,
                                            level: "sentence",
                                            content: " Interpretation:"
                                        },
                                        {
                                            start: 199,
                                            end: 270,
                                            level: "sentence",
                                            content: " No birefringent crystals identified (admixed blood limits evaluation)."
                                        }
                                    ]
                                }
                            },
                            {
                                type: "Ngram",
                                score: 0.000005559965499666767,
                                feature: {
                                    slop: 1,
                                    field: "raw_body",
                                    in_order: true,
                                    ngram: "identifi blood",
                                    type: "ngram",
                                    spans: [
                                        {
                                            start: 225,
                                            end: 250,
                                            level: "ngram",
                                            content: "identified (admixed blood"
                                        },
                                        {
                                            start: 199,
                                            end: 270,
                                            level: "sentence",
                                            content: " No birefringent crystals identified (admixed blood limits evaluation)."
                                        }
                                    ]
                                }
                            },
                            {
                                type: "Ngram",
                                score: 0.000005559965499666767,
                                feature: {
                                    slop: 1,
                                    field: "raw_body",
                                    in_order: true,
                                    ngram: "interpret no",
                                    type: "ngram",
                                    spans: [
                                        {
                                            start: 183,
                                            end: 202,
                                            level: "ngram",
                                            content: "Interpretation:\n No"
                                        },
                                        {
                                            start: 182,
                                            end: 198,
                                            level: "sentence",
                                            content: " Interpretation:"
                                        },
                                        {
                                            start: 199,
                                            end: 270,
                                            level: "sentence",
                                            content: " No birefringent crystals identified (admixed blood limits evaluation)."
                                        }
                                    ]
                                }
                            }
                        ],
                        used: true
                    }
                ]
            }
        ]
    }
];
//# sourceMappingURL=multipleSubmitted.fixture.js.map